export const colorMap = {
    Active: "status-success",
    Expired: "status-high",
    Archived: "status-pending",
};
